<template>
    <!-- quando for usar em componentes diferentes, nao esquecer de passar a prop masonryId como se fosse um v-model, se nao buga os demais grids -->
    <div
        class="mt-4 pb-6"
        v-masonry="masonryId"
        column-width=".grid-item"
        transition-duration="0.3s"
        item-selector=".grid-item"
    >
        <template>
            <div
                v-masonry-tile
                v-for="(post, index) in media"
                :key="index"
                class="grid-item cursor-pointer"
            >
                <div
                    class="post-foto"
                    :class="[isSelected(post.content) ? 'active' : '', 'fade-in']"
                >
                    <div
                        @click="manageMedia(post, index)"
                    >
                        <base-image
                            ref="baseImage"
                            :source="post.content"
                            :externalImage="false"
                            :customClass="'img-fluid'"
                            :fitIn="'230x0'"
                        />
                        <div v-if="inGallery && inGallery(post.content)" class="in-post">
                            <span class="text-add position-absolute ps-t-0 ps-l-0 m-2">
                                Adicionada
                            </span>
                        </div>
                    </div>

                    <div v-if="(post.name != null && post.extension != null)" class="name-image-container position-absolute ps-b-0 ps-r-0">
                        <span>
                            {{ nameFormated ? nameFormated(post.name + '.' + post.extension) : post.name }}
                        </span>
                    </div>


                    <div class="delete-image-container position-absolute ps-b-0 ps-r-0 m-2">
                        <!-- copiar link -->
                        <button
                            v-b-tooltip
                            title="Copiar link"
                            class="btn btn-block btn-primario px-2 py-0"
                            @click="copyUrl(post)"
                        >
                            <i class="fal fa-regular fa-copy font-14"></i>
                        </button>

                        <!-- deletar media -->
                        <button
                            v-b-tooltip.hover="{customClass: 't-tooltip'}"
                            title="Excluir"
                            class="btn btn-block btn-primario px-2 py-0"
                            @click="deleteMedia(post, index)"
                        >
                            <i class="fal fa-trash-alt font-14" aria-hidden="true"></i>
                        </button>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import Vue from 'vue';
import {VueMasonryPlugin} from 'vue-masonry';
import BaseImage from './BaseImage.vue';

Vue.use(VueMasonryPlugin);

export default {
    name: 'MasonryDisplay',
    components: {
        BaseImage
    },
    props: {
        media: {
            type: Array,
            required: true
        },
        masonryId: {
            type: String,
            required: true,
        },
        isSelected: {
            type: Function,
            required: false,
        },
        manageMedia: {
            type: Function,
            required: false,
        },
        inGallery: {
            type: Function,
            required: false,
        },
        nameFormated: {
            type: Function,
            required: false,
        },
        deleteMedia: {
            type: Function,
            required: false,
        },
    },
    methods: {
        copyUrl(post) {
            if (post.type === 'image') {
                this.$emit('copyImageLink', this.$refs.baseImage.find(img => img.source === post.content));
            } else {
                this.$emit('copyVideoLink', post);
            }
        },
        updateMasonryLayout() {
            // POSICIONA
            setTimeout(() => {
                this.$redrawVueMasonry(this.masonryId);
            }, 1000);

            // REAJUSTA SE PRECISO
            const interval = setInterval(() => {
                this.$redrawVueMasonry(this.masonryId);
            }, 2000);

            // PARA DE REAJUSTAR
            setTimeout(() => {
                clearInterval(interval);
            }, 10000);
        }
    },
    watch: {
        media: {
            handler() {
                this.updateMasonryLayout();
            },
            deep: true
        }
    }
}
</script>

<style scoped>
    .grid-item {
        width: 50%;
        border: none !important;
    }

    .text-add {
        font-size: 0.875rem;
        color: white;
        text-shadow: 2px 2px rgba(0, 0, 0, 0.16);
    }

    @media screen and (min-width: 576px) {
        .grid-item {
            width: 16.6%;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/atoms/MasonryDisplay.vue